import { render, staticRenderFns } from "./TabellaCicloStandard.vue?vue&type=template&id=03596638&scoped=true&"
import script from "./TabellaCicloStandard.vue?vue&type=script&lang=js&"
export * from "./TabellaCicloStandard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03596638",
  null
  
)

export default component.exports